var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Loader, Switch, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useEsigning } from 'app/domains/esigning/components/EsigningProvider';
import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { useUpdateEsigningSettings } from 'app/domains/esigning/hooks/useUpdateEsigningSettings';
import { Setting } from '../Setting';
export function SigningOrder() {
    const { requireOrder } = useEsigningSettings();
    const { updateSigningOrder } = useUpdateEsigningSettings();
    const { submittingCreation } = useEsigning();
    const { addToast } = useToast();
    const [loading, setLoading] = useState(false);
    const handleChange = (checked) => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield updateSigningOrder(checked);
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Could not update signing order setting',
                    comment: 'Toast message for error when updating eSigning signing order setting',
                }),
            });
        }
        setLoading(false);
    });
    return (<Setting icon={loading ? <Loader size={8}/> : <Falcon icon="arrow-down-arrow-up"/>} label={t({
            comment: 'Label for e-signing setting signing order',
            message: 'Signing order',
        })} description={t({
            comment: 'Description for e-signing setting signing order',
            message: 'Set the preferable signing order',
        })} endElement={<Switch checked={requireOrder} disabled={loading || submittingCreation} onCheckedChange={handleChange}/>}/>);
}
